'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _colors = require('./utils/colors');

var _colors2 = _interopRequireDefault(_colors);

var _directionalstyles = require('./utils/directionalstyles');

var _directionalstyles2 = _interopRequireDefault(_directionalstyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var rtl = _ref.rtl,
        _ref$fontFamily = _ref.fontFamily,
        fontFamily = _ref$fontFamily === undefined ? 'ArialMT, Arial, tahoma, HelveticaNeue' : _ref$fontFamily,
        _ref$paddingVertical = _ref.paddingVertical,
        paddingVertical = _ref$paddingVertical === undefined ? 36 : _ref$paddingVertical,
        _ref$paddingHorizonta = _ref.paddingHorizontal,
        paddingHorizontal = _ref$paddingHorizonta === undefined ? 60 : _ref$paddingHorizonta,
        marginTop = _ref.marginTop;

    var _styles = {
        cancellationReason: {
            fontFamily: fontFamily,
            margin: paddingVertical + 'px ' + paddingHorizontal + 'px'
        },

        cancellationReasonInner: {
            backgroundColor: '#f4fafe',
            padding: 18,
            borderRadius: 6
        },

        cancellationReasonTitle: {
            fontSize: 10,
            letterSpacing: 1,
            textTransform: 'uppercase',
            color: _colors2.default.D40,
            marginBottom: 12
        }
    };

    if (typeof marginTop === 'number') {
        _styles.cancellationReason.marginTop = marginTop;
    }

    return (0, _directionalstyles2.default)(_styles, rtl);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/CancellationReason.style.js
// module id = 1153
// module chunks = 0